<div class="container">
    <div class="awaiting-approval-container">
        <h2 class="awaiting-approval-title">{{'awaiting_approval.title' | translate}}</h2>
        <div>{{'awaiting_approval.body' | translate}}</div>
    </div>
</div>